import { TOrganization } from "@/features/organizations/types";

export interface IUser {
  id?: string;
  firstName: string;
  lastName: string;
  displayName: string;
  phoneNumber: string;
  password?: string;
  postalCode: string;
  email: string;
  personalEmail: string;
  country: string;
  province: string;
  city: string;
  address: string;
  birthDate: string;
  description: string;
  mfaEnforced: boolean;
  mfaAllowedType: "totp" | "email" | "webauthn";
  mfaEnrollmentGracePeriod: number;
  temporaryPassword: boolean;
  profile: File | string | undefined;
  lastLogin?: string | null;
  forcedToChangePassword: boolean;
  userOrganizations?: {
    organizationId: string;
    roleId: string;
    isSelected: boolean;
  }[];
  roleId: string;
}

export type TCreateMspAdminResponse = {
  id: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  companyId: string;
  email: string;
  address: string;
  birthDate: string;
  city: string;
  country: string;
  description: string;
  displayName: string;
  personalEmail?: string;
  province: string;
  mfaEnforced: boolean;
  postalCode: string;
  preferredMfaType: "totp" | "email" | "webauthn";
  mfaEnrollmentGracePeriod: string;
  mfaActive: boolean;
  isOwner: boolean;
  status: "ACTIVE" | "INACTIVE";
};

export type TAdminParamsType = {
  page: number;
  limit: number;
  orderBy?: "name";
  orderDirection?: "ASC" | "DESC";
  search?: string;
};

export interface IUserResponse {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  profile: string | null;
  email: string;
  personalEmail: string;
  firstName: string;
  lastName: string;
  displayName: string;
  mfaEnforced: boolean;
  mfaActive: boolean;
  mfaEnrollmentGracePeriod: string;
  multiFactorAuths: null;
  preferredMfaType: "totp" | "email" | "webauthn";
  country: string;
  province: string;
  city: string;
  address: string;
  birthDate: string;
  description: string;
  postalCode: string;
  password: string;
  phoneNumber: string;
  lastLogin: string | null;
  isOwner: boolean;
  status: "ACTIVE" | "INACTIVE";
  forcedToChangePassword: boolean;
  companyId: string;
  temporaryPassword: boolean;
  userOrganizations?: {
    id: string;
    createdAt: string;
    updatedAt: string;
    deletedAt: null;
    userId: string;
    organizationId: string;
    roleId: string;
    roleName: string;
    employeeId: string;
    organization?: Omit<TOrganization, "owner">;
  }[];
  role?: {
    id: string;
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
    name: string;
    description: string;
    permissions: string[];
  };
}

export enum EMspAdminRole {
  OWNER = "Owner",
  IT_ADMIN = "IT Admin",
  BILLING = "Billing",
  SUPERADMIN = "Super Admin",
}
